module.exports = "<div *ngIf=\"html\" [innerHtml]=\"html\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/html-resource/html-resource.component.html
// module id = Oa82
// module chunks = 1